import script from "./ActionsTimer.vue?vue&type=script&setup=true&lang=js"
export * from "./ActionsTimer.vue?vue&type=script&setup=true&lang=js"

import "./ActionsTimer.vue?vue&type=style&index=0&id=871a1514&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-871a1514"]])

export default __exports__